interface Props {
  onClick: () => void;
  disabled: boolean;
}

const SvgPlus: React.FC<Props> = ({ onClick, disabled }) => {
  return (
    <svg
      onClick={disabled ? undefined : onClick}
      style={{ cursor: "pointer" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15267_16099)">
        <path
          d="M5.98815 1.18905C5.77612 1.19216 5.57399 1.27932 5.42618 1.43137C5.27837 1.58343 5.19697 1.78795 5.19987 1.99999V5.19999H1.99987C1.89386 5.19849 1.78861 5.21807 1.69024 5.25761C1.59186 5.29714 1.50232 5.35582 1.42683 5.43026C1.35133 5.5047 1.29138 5.59339 1.25047 5.6912C1.20955 5.78901 1.18848 5.89397 1.18848 5.99999C1.18848 6.10601 1.20955 6.21097 1.25047 6.30878C1.29138 6.40658 1.35133 6.49528 1.42683 6.56972C1.50232 6.64415 1.59186 6.70284 1.69024 6.74237C1.78861 6.7819 1.89386 6.80149 1.99987 6.79999H5.19987V9.99999C5.19837 10.106 5.21796 10.2112 5.25749 10.3096C5.29702 10.408 5.35571 10.4975 5.43014 10.573C5.50458 10.6485 5.59328 10.7085 5.69108 10.7494C5.78889 10.7903 5.89385 10.8114 5.99987 10.8114C6.10589 10.8114 6.21085 10.7903 6.30866 10.7494C6.40647 10.7085 6.49516 10.6485 6.5696 10.573C6.64403 10.4975 6.70272 10.408 6.74225 10.3096C6.78179 10.2112 6.80137 10.106 6.79987 9.99999V6.79999H9.99987C10.1059 6.80149 10.2111 6.7819 10.3095 6.74237C10.4079 6.70284 10.4974 6.64415 10.5729 6.56972C10.6484 6.49528 10.7084 6.40658 10.7493 6.30878C10.7902 6.21097 10.8113 6.10601 10.8113 5.99999C10.8113 5.89397 10.7902 5.78901 10.7493 5.6912C10.7084 5.59339 10.6484 5.5047 10.5729 5.43026C10.4974 5.35582 10.4079 5.29714 10.3095 5.25761C10.2111 5.21807 10.1059 5.19849 9.99987 5.19999H6.79987V1.99999C6.80133 1.89302 6.78133 1.78685 6.74105 1.68775C6.70076 1.58865 6.64101 1.49864 6.56533 1.42303C6.48966 1.34742 6.39958 1.28776 6.30045 1.24757C6.20131 1.20738 6.09512 1.18748 5.98815 1.18905Z"
          className={`${disabled ? "fill-gray4" : "fill-primary"}`}
        />
      </g>
      <defs>
        <clipPath id="clip0_15267_16099">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgPlus;
